import { Carrier } from "./carriers.js";
export const ARK_LIFE_ORGANIZATION_ID = "org_ark_life_group";
/**
 * The only carriers an Ark Life agent may be offered during contracting (Ark
 * Life Carriers List, agency AA0002). The same limit applies to anyone whose
 * direct upline is Ark Life Group. Stored as the lowercase carrier values the
 * contracting form and `Organization.eligibleCarriers` use.
 */
export const ARK_LIFE_CARRIERS = [
    Carrier.AMERICAN_AMICABLE,
    Carrier.ROYAL_NEIGHBORS,
    Carrier.AFLAC,
    Carrier.TRANSAMERICA,
    Carrier.COREBRIDGE,
    Carrier.GERBER,
    Carrier.FORESTERS,
    Carrier.BALTIMORE_LIFE,
    Carrier.MUTUAL_OF_OMAHA,
];
export const ARK_LIFE_CARRIER_VALUES = ARK_LIFE_CARRIERS.map((carrier) => carrier.toLowerCase());
